<template>
  <div class="instInputWrap">
    <div class="instInputPosition" v-bind:class="{issetError:fieldStatus.ShowError && fieldStatus.code > 0}">
      <input
        :id="'f'+fieldName"
        :type="item.type"
        :name="fieldName"
        v-model.trim="value"
        v-on:blur="eventBlur"
        v-on:focus="eventFocus"
        v-if="item.mask.length > 0"
        v-mask="item.mask"
        autocomplete="off"
      >
      <input
        :id="'f'+fieldName"
        :type="item.type"
        :name="fieldName"
        v-model.trim="value"
        v-on:blur="eventBlur"
        v-on:focus="eventFocus"
        v-else
      >
      <label :for="'f'+fieldName" v-bind:class="{active:value.length > 0 || inFocus}">{{item.label}}</label>
    </div>
    <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>
  </div>
</template>

<script>
import DataForInput from '@/store/Form/longFormOptions';
import {mapState} from "vuex";


export default {
  name: "instInput",
  data: function () {
    return {
      inFocus: false,
      item: DataForInput[this.fieldName],
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  methods: {
    eventBlur: function () {
      // this.$palantir.trackInputBlur(this.refs,this.valueVuex[this.refs]);
      this.inFocus = false;
      this.$store.dispatch('errorShow', {
        target: this.fieldName,
        value: true,
      });
    },
    eventFocus: function () {
      // this.$palantir.trackInputFocus(this.refs);
      this.inFocus = true;
      this.$store.dispatch('errorShow', {
        target: this.fieldName,
        value: false,
      });
    }
  },
  computed: {
    ...mapState({
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    },
    value: {
      get() {
        return this.valueVuex[this.fieldName];
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: value
        });
      }
    },
  }
}
</script>

<style scoped>

</style>